import { StatusColorLegend } from "./StatusColorLegend";

export default StatusColorLegend;
